import { render, staticRenderFns } from "./ImgLinkValue.vue?vue&type=template&id=5335beb4&scoped=true&"
import script from "./ImgLinkValue.vue?vue&type=script&lang=ts&"
export * from "./ImgLinkValue.vue?vue&type=script&lang=ts&"
import style0 from "./ImgLinkValue.vue?vue&type=style&index=0&id=5335beb4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5335beb4",
  null
  
)

export default component.exports